module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAKBJREFUeNpi5GlwYCAFMDGQCOisIdrAY1t8v56ECoQLZAC5QEFkNSwoGvTdbRUMgIq8FhYCuUAGPwcPkLH0wg64GkbkUIIYCVT08ccXIBfCAGq+9OIOdicBJYDSQEVApVhVU+xpZCdB7EEOAywaOtyz4S6Buw0oiKyGmc1BAcFjZASqSFzbDHT3yy/v9tw9rSYit/TizstI3mAcBmkJIMAAZdZOxJVnCrAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/delete2.png
// module id = 612
// module chunks = 1 6